function NRSendIcon({ color = 'currentColor', height = '24', width = '24' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M3 20V4L22 12L3 20ZM5 17L16.85 12L5 7V10.5L11 12L5 13.5V17Z" fill={color} />
    </svg>
  );
}

export default NRSendIcon;
